import { memo, useMemo } from "react";
import { useSelector } from "react-redux";

import classNames from "common/class-names";

import ActionEnum from "enum/action";

import { RootStateDto } from "dto/redux/store-dto";

const AppAlert = () => {
	const alert = useSelector((state: RootStateDto) => state.alert);

	const alertClassName = useMemo(() => classNames({ alert__text: true, "alert__text--error": alert.error, "alert__text--success": !alert.error && alert?.action === ActionEnum.Update }), [alert?.action, alert.error]);

	const code = useMemo(() => (alert.code ? ` (${alert.code})` : ""), [alert.code]);

	if (!alert.message) return null;

	return (
		<div className="app-alert">
			<div className="alert">
				<p className={alertClassName}>
					<span>
						{alert.message}
						{code}
					</span>
				</p>
			</div>
		</div>
	);
};

export default memo(AppAlert);
